export default __webpack_public_path__ + "static/robot-magnifying-b22493d1dfe3a4e9427df532fc25dc0c.png";